module.exports = __webpack_public_path__ + "s/img/cuticles.394a74a6.svg";